<template>
  <div class="confirm-form">
    <div class="form-group">
      <h4 for="storage-amount">{{ inputLabel }}</h4>
      <input class="form-control custom-input" type="text" id="storage-amount" ref="input" :readonly="editable === false"
        v-model="content" />
    </div>
    <div class="button-wrap">
      <button class="btn btn-lg confirm-button" @click="setText">確認</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirmStorage',
  props: {
    defaultContent: String,
    inputLabel: String,
    editable: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      content: '',
    };
  },
  created() {
    // this.content = this.defaultContent;
  },
  mounted() {
    console.log(this.defaultContent);
    this.content = this.defaultContent;
    this.$refs.input.focus();
  },
  computed: {
    currentApp() {
      return this.$store.state.currentApp;
    },
  },
  methods: {
    setText() {
      this.$emit('setText', this.content);
    },
  },
  watch: {
    defaultContent(val) {
      this.content = val;
    },
  },
};
</script>



// WEBPACK FOOTER //
// TextInput.vue?e78cb376